// cities

import List from '../../pages/Places/Cities/List';
import Detail from '../../pages/Places/Cities/Detail';

export const subRoutesCities = [
    {
        path: "",
        component: List,
        exact: true,
    }
].map((item) => {
    return {
        ...item,
        path: `/cities${item.path}`,
        private: true
    };
});

export const routesCities = [
    {
        path: "/:elementId",
        component: Detail,
    }
].map((item) => {
    return {
        ...item,
        path: `/cities${item.path}`,
        private: true
    };
});